var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayforgoods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44 24V34C44 40 40 44 34 44H14C8 44 4 40 4 34V24C4 18.56 7.28 14.76 12.38 14.12C12.9 14.04 13.44 14 14 14H34C34.52 14 35.02 14.02 35.5 14.1C40.66 14.7 44 18.52 44 24Z",
    fill: "#005948"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5009 14.1C35.0209 14.02 34.5209 14 34.0009 14H14.0009C13.4409 14 12.9009 14.04 12.3809 14.12C12.6609 13.56 13.0609 13.04 13.5409 12.56L20.0409 6.04C22.7809 3.32 27.2209 3.32 29.9609 6.04L33.4609 9.58004C34.7409 10.84 35.4209 12.44 35.5009 14.1Z",
    fill: "#005948"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25H38C35.8 25 34 26.8 34 29C34 31.2 35.8 33 38 33H44",
    fill: "#005948"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayforgoods);
export default __webpack_public_path__ + "static/media/payforgoods.1588eaed124cd26fa156990e973e3434.svg";
export { ForwardRef as ReactComponent };